//@file:PackageMapping("{id}")
package com.ervasstudio.tracoemovimento.pages.blog

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.ervasstudio.tracoemovimento.components.sections.Header
import com.ervasstudio.tracoemovimento.model.BlogPost
import com.ervasstudio.tracoemovimento.model.NewsState
import com.ervasstudio.tracoemovimento.repository.BlogRepository
import com.ervasstudio.tracoemovimento.util.rememberIsMobile
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.PackageMapping
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.vw

@Page("{id?}")
@Layout(".components.layouts.PageLayout")
@Composable
fun BlogPage() {

    val ctx = rememberPageContext()
    var postId = ctx.route.params["id"] // null se estiver em /blog sem id
    console.log("blog post $postId")



    // Chave para persistência no navegador
    val localStorageKey = "traco_movimento_newsletter_registrado"
    val sessionStorageKey = "traco_movimento_newsletter_sessao_registrado"

    val isMobile = rememberIsMobile()

    var isLoading by remember { mutableStateOf(true) }
    var selectedPost by remember { mutableStateOf<BlogPost?>(null) }
    var listOfPosts by remember { mutableStateOf<List<BlogPost>>(emptyList()) }


    LaunchedEffect(postId) {
        isLoading = true

        if (listOfPosts.isEmpty()) {
            listOfPosts = BlogRepository.fetchPosts(limite = 9)
        }

        selectedPost = if (!postId.isNullOrBlank()) {
            BlogRepository.fetchPostById(postId)
        } else {
            BlogRepository.fetchFeaturedPost()
        }

        isLoading = false

        // Opcional: Rola a janela para o topo suavemente ao mudar de post
        document.getElementById("topo-do-blog")?.scrollIntoView()

    }



    Column(
        modifier = Modifier.fillMaxWidth().fillMaxHeight(),
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Header(expandedItem = 3, isMobile = isMobile)

        MainSectionBlog(
            isLoading = isLoading,
            selectedPost = selectedPost,
            listOfPosts = listOfPosts,

            onPostClick = {
                ctx.router.navigateTo("/blog/${it.id}")
            },
            localStorageKey = localStorageKey,
            sessionStorageKey = sessionStorageKey,
            isMobile = isMobile
        )
    }
}